import type { WbsClient } from '@bldsoft/cappie/api/wbs'
import type { API } from '@setplex/tria-api'
import type { AdapterDefaults } from '../../index.h'

import { ensureOk, payload } from '@bldsoft/cappie/rest'
import * as v from 'valibot'
import {
  ProfileSchema,
  ProfilesListSchema,
  ProfileSummarySchema,
} from './schemas/profiles'

export function use(
  client: WbsClient,
  profiles: API['profiles'],
  _api: API,
  _defaults: AdapterDefaults
): void {
  profiles.getProfilesSummaryFx.use(async () => {
    const json = await payload(client.get.api.v3.profiles.summary())
    return v.parse(ProfileSummarySchema, json)
  })

  profiles.getProfilesFx.use(async () => {
    const json = await payload(client.get.api.v3.profiles())
    return v.parse(ProfilesListSchema, json)
  })

  profiles.getActiveProfileFx.use(async () => {
    const json = await payload(client.get.api.v3.profiles.active())
    return v.parse(ProfileSchema, json)
  })

  profiles.updateProfileFx.use(async (body) => {
    const { id } = body
    await ensureOk(client.put.api.v3.profiles(id, { body }))
  })

  profiles.removeProfileFx.use(async ({ id }) => {
    await ensureOk(client.delete.api.v3.profiles(id))
  })

  profiles.updateProfileActiveStateFx.use(async (profileId) => {
    await ensureOk(client.patch.api.v3.profiles(profileId).active())
  })

  profiles.createProfileFx.use(async (body) => {
    const json = await payload(client.post.api.v3.profiles({ body }))
    return v.parse(ProfileSchema, json)
  })
}
